import { render } from "./BaseRouteBar.vue?vue&type=template&id=62dcc02c"
import script from "./BaseRouteBar.vue?vue&type=script&lang=js"
export * from "./BaseRouteBar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__